import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { WissalstoreService } from "../../Services/wissalstore.service";
//import {Product, ProductItems} from "../../Core/products/products";
import { ProductService } from "../../Services/product.service";
import { debounceTime, filter, map, skip } from "rxjs/operators";
import { distinctUntilChanged } from "rxjs/internal/operators/distinctUntilChanged";
import { switchMap } from "rxjs/internal/operators/switchMap";
import { Page } from "../../Models/page";
import { Product } from "../../Models/product";
import { AccountService } from "src/app/Services/account.service";
import { AuthenticationService } from "src/app/Services/authentification/services/authentication.service";
import { ProjectTheme } from "src/app/Models/ProjectTheme";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { CategoryService } from "src/app/Services/category.service";
import { Category } from "src/app/Models/category";
import { CartService } from "src/app/Services/cart.service";
import { BrandService } from "src/app/Services/brand.service";
import { Brand } from "src/app/Models/brand";
import { CartOffLineService } from "src/app/Services/cartOffline.service";
import { FavoriteService } from "src/app/Services/favorite.service";
import {
  AccountMenuItem,
  CategoryMenuModel,
  HeaderAnnouncement,
  HeaderQuickLink,
  HeaderTab,
  HeaderComponent as LibHeaderComponent,
} from "admin-common";
import { ProductConfigurationService } from "src/app/Services/product-configuration.service";
import { AuthGuard } from "src/app/Services/authentification/guards/auth.guard";
import { StorageService } from "../../Services/storage.service";
import { TranslationService } from "src/app/Services/translation.service";
import { LanguageService } from "src/app/Services/language.service";
import {
  LayoutTexts,
  LayoutTextsService,
} from "src/app/Services/layout-texts.service";

/**
 * Navigation row links; `key` is the label under `layout.header.tabs`. Same as setycore minus its "Dossier client"
 * (no such page here; the stores page is already a quick link on the right).
 * Only pages that exist: add "Nouveautés" / "Destockage" / "À propos" back once they have a page.
 */
const HEADER_TABS: (Omit<HeaderTab, "label"> & { key: string })[] = [
  { key: "home", link: "/", mainTab: false },
  { key: "allProducts", link: "/products", mainTab: false, highlight: true },
  { key: "contactUs", link: "/contact", mainTab: false },
];

/**
 * Quick links; `id` is also the label key under `layout.header.quickLinks`. "Comment ça marche" is left out:
 * the app has no page for it yet (add `{ id: "how-works", ... }` and bind `(howWorks)` when it does).
 */
const HEADER_QUICK_LINKS: Omit<HeaderQuickLink, "label">[] = [
  { id: "stores", iconName: "building-02", highlight: true },
  { id: "help", iconName: "help-circle" },
];

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false
})
export class HeaderComponent implements OnInit {
  mosaiqueBackgroundImage: string = "assets/images/moasiqueWU.svg";
  phoneNumber: string = "+213 770 61 77 16";
  bankLogoSrc: string = "assets/icons/wulogo.png";
  ekiclikLogoSrc: string = "assets/icons/svgs/Eki.svg";
  // Transparent PNG: wuLogo.svg paints a white rectangle behind the logo, which shows as a white box on the header
  wissalUniverLogoSrc: string = "assets/icons/wulogo.png";
  categories: CategoryMenuModel[] = [];
  theme: ProjectTheme = "WUnivers";
  searchSuggestions: string[] = [];
  brands: Brand[] = [];
  orderItemsNumber?: number;
  isMobileMenuOpen = false;
  placeholder: string = "";
  searchResults: Product[] = [];
  response?: Page<Product>;
  isNavbarFixed = false;
  isNavbar = true;
  isConnected = false;
  isLoginModalVisible: boolean = false;
  isForgotPasswordModalVisible: boolean = false;

  isRegistrationModalVisible: boolean = false;
  forgotPasswordEmail?: string;
  showLanguagesDropdown: boolean = true;
  currentLang = new FormControl<string>(inject(LanguageService).current);
  user_name: string = "";
  user_email: string = "";
  hoverdCategoryId!: number; //used to filter brands by
  showMyAccountDropdownMenu: boolean = false;
  myAccountDropdownPosition = { top: 0, right: 0 };

  @ViewChild(LibHeaderComponent)
  private libHeaderComponent?: LibHeaderComponent;

  @ViewChild("headerWrapper")
  private headerWrapperRef?: ElementRef<HTMLElement>;

  @ViewChild("accountDropdown")
  private accountDropdownRef?: ElementRef<HTMLElement>;
  readonly DEFAULT_PRODUCT_IMAGE = "assets/images/logo_placeholder.png";

  toggleLoginModal(isVisible: boolean): void {
    if (isVisible) {
      // Fermer d'abord tous les modals
      this.isLoginModalVisible = false;
      this.isForgotPasswordModalVisible = false;
      this.isRegistrationModalVisible = false;

      // Forcer Angular à détecter le changement
      setTimeout(() => {
        this.isLoginModalVisible = true;
      });
    } else {
      this.isLoginModalVisible = false;
    }
  }

  private searchTerms = new BehaviorSubject<string>("");

  toggleForgotPasswordModal(email?: string): void {
    this.isForgotPasswordModalVisible = !this.isForgotPasswordModalVisible;
    this.forgotPasswordEmail = email;
    if (this.isForgotPasswordModalVisible) {
      this.isLoginModalVisible = false;
      this.isRegistrationModalVisible = false;
    }
  }

  // Toggle subscription/registration modal visibility
  toggleSubscriptionModal(): void {
    this.isRegistrationModalVisible = !this.isRegistrationModalVisible;

    // Close other modals if opening this one
    if (this.isRegistrationModalVisible) {
      this.isLoginModalVisible = false;
      this.isForgotPasswordModalVisible = false;
    }
  }

  cartCount$: Observable<number>;
  favoritesNumber$: Observable<number>;

  /** Links of the header's navigation row (also listed under "En ce moment" in the menu). */
  tabs: HeaderTab[] = HEADER_TABS.map(({ key, ...tab }) => ({ ...tab, label: "" }));

  /** Marketing bar under the header (see LayoutTextsService); null hides it. */
  announcement: HeaderAnnouncement | null = null;

  /** Utility links on the right of the navigation row and in the menu. */
  quickLinks: HeaderQuickLink[] = [];

  /**
   * Texts of the library header (`layout.header.*`); empty until the translations are loaded,
   * the library then shows its French defaults.
   */
  labels: Record<string, string> = {};
  tabulationLabels: Record<string, string> = {};
  logoutLabel: string = "";

  /** Entries of the "my account" dropdown, same as setycore; `route` drives the active highlight (log out is built in). */
  menuItems: (AccountMenuItem & { route: string; labelKey: string })[] = [
    {
      label: "",
      labelKey: "profile",
      icon: "user",
      route: "/account/profile",
      handler: () => this.onMyProfileClick(),
    },
    {
      label: "",
      labelKey: "orders",
      icon: "orders",
      route: "/account/orders",
      handler: () => this.onMyOrdersClick(),
    },
    {
      label: "",
      labelKey: "favorites",
      icon: "favorites",
      route: "/account/favorites",
      handler: () => this.onMyFavoritesClick(),
    },
    {
      label: "",
      labelKey: "addresses",
      icon: "address",
      route: "/account/address",
      handler: () => this.onMyAdressClick(),
    },
  ];

  searchText: string = "";
  /** searched text currently in the url, used to detect when it is removed */
  private searchParam: string = "";

  constructor(
    private storage: StorageService,
    public wissalStoreService: WissalstoreService,
    private productService: ProductService,
    private productConfigurationService: ProductConfigurationService,
    public accountService: AccountService,
    public cartService: CartService,
    private offlineCartService: CartOffLineService,
    private favoriteService: FavoriteService,
    private categoryService: CategoryService,
    private authService: AuthenticationService,
    private brandService: BrandService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService,
    private languageService: LanguageService,
    private layoutTexts: LayoutTextsService,
    private translate: TranslateService,
  ) {
    this.favoritesNumber$ = this.favoriteService.favoritesCount$;

    this.currentLang.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((lang) => {
        this.switchLanguage(lang ?? "fr");
      });

    // categories come from the backend in the current language
    this.languageService.language$
      .pipe(skip(1), takeUntilDestroyed())
      .subscribe(() => this.getActivatedCategories());

    // rebuild the texts handed to the library header whenever the language changes
    this.layoutTexts.layout$
      .pipe(takeUntilDestroyed())
      .subscribe((layout) => this.applyTranslations(layout.header));
    this.layoutTexts.announcement$
      .pipe(takeUntilDestroyed())
      .subscribe((announcement) => (this.announcement = announcement));

    /**
     * Observable to hold the number of cart items in both modes online and offline
     */
    this.cartCount$ = this.accountService.accountSubject.pipe(
      switchMap((client) => {
        if (client) {
          // Online cart for logged-in users
          return this.cartService.cart.pipe(
            map((cart) =>
              cart.reduce((sum, item) => sum + (item.quantity ?? 0), 0),
            ),
          );
        } else {
          // Offline cart for guest users
          return this.offlineCartService.cart$.pipe(
            map((cart) =>
              (cart.CartProduct ?? []).reduce(
                (sum, item) => sum + (item.quantity ?? 0),
                0,
              ),
            ),
          );
        }
      }),
    );
  }

  ngOnInit(): void {
    const openLoginDialogue =
      this.storage.getItem("openLoginDialogue") === "true";
    this.storage.removeItem("openLoginDialogue");

    if (openLoginDialogue) {
      this.isLoginModalVisible = true;
    }

    this.setSelectedTab(this.router.url);
    this.setActiveMenuItem(this.router.url);
    this.searchParam = this.getSearchParam(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setSelectedTab(event.urlAfterRedirects);
        this.setActiveMenuItem(event.urlAfterRedirects);
        //the searched text was removed from the url (e.g. a catalogue filter changed): empty the search bar
        const searchParam = this.getSearchParam(event.urlAfterRedirects);
        if (this.searchParam && !searchParam) {
          this.clearSearchBar();
        }
        this.searchParam = searchParam;
        if (this.storage.getItem("openLoginDialogue") === "true") {
          this.storage.removeItem("openLoginDialogue");
          this.toggleLoginModal(true);
        }
      });

    this.authService.refreshSession().subscribe();

    this.accountService.accountSubject.subscribe((client) => {
      if (client) {
        this.isConnected = true;
        this.user_name = client.username ?? "";
        this.user_email = client.email ?? "";
      } else {
        this.isConnected = false;
        this.user_name = "";
        this.user_email = "";
      }
    });
    this.searchTerms
      .pipe(
        debounceTime(300),
        map((text) => text.trim()),
        filter((text) => text.length >= 2),
        distinctUntilChanged(),
        switchMap((term) =>
          this.productService.getByFilter(
            { query: term, inStock: "true" },
            null as any,
            undefined,
            undefined,
            true,
          ),
        ),
      )
      .subscribe((res: any) => {
        this.searchResults = res.page.content;

        if (!this.searchResults || this.searchResults.length === 0) {
          this.searchSuggestions = [this.noResultsLabel];
        } else {
          this.searchSuggestions = this.searchResults.map((p: any) => p.name);
        }
      });

    this.getActivatedCategories();
  }

  /**
   * @description get the searched text from the url (`search` query param)
   * @param {string} url the current url
   */
  private getSearchParam(url: string): string {
    return this.router.parseUrl(url).queryParams["search"] ?? "";
  }

  /**
   * @description empty the search bar text and its suggestions
   */
  private clearSearchBar(): void {
    this.libHeaderComponent?.clearSearch();
    this.searchText = "";
    this.searchSuggestions = [];
  }

  onSearchInputChange(text: string): void {
    this.searchTerms.next(text);
    this.searchText = text;
  }

  private get noResultsLabel(): string {
    return this.translate.instant("layout.header.noResults");
  }

  switchLanguage(lang: string): void {
    this.translationService.setLanguage(lang);
  }

  getActivatedCategories() {
    this.categoryService.getAllActivated().subscribe({
      next: (categories: Category[]) => {
        // CategoryService publishes them to its `categories` subscribers
        this.categories = [];
        this.structureCategories(categories);
      },
      error: () => {
        this.categoryService.categoriesSubject.next([]);
      },
    });
  }

  onTabClick(data: HeaderTab) {
    if (data.mainTab) return;
    this.router.navigateByUrl(data.link, { skipLocationChange: false }).then();
  }

  structureCategories(categories: Category[]) {
    this.categories = [];
    this.parentCategories(categories).forEach((parent) => {
      const cat: any = {
        label: parent.label,
        href: this.createHref(parent.label, parent.id!), // niveau 1
        id: parent.id,
        icon: parent.image,
        subcategories: [],
      };

      this.subCategories(categories, parent.id!).forEach((child) => {
        const subCat: any = {
          label: child.label,
          href: this.createHref(
            parent.label,
            parent.id!,
            child.label,
            child.id!,
          ), // niveau 2
          image: child.image,
          subcategories: [],
        };

        this.subCategories(categories, child.id!).forEach((subChild) => {
          subCat.subcategories.push({
            label: subChild.label,
            image: subChild.image,
            href: this.createHref(
              parent.label,
              parent.id!,
              child.label,
              child.id!,
              subChild.id!,
            ), // niveau 3
          });
        });
        cat.subcategories.push(subCat);
      });
      this.categories.push(cat);
    });
  }

  parentCategories(categories: Category[]): Category[] {
    return categories.filter(
      (category: Category) => category.parentId === null,
    );
  }

  subCategories(categories: Category[], id: number): Category[] {
    return categories.filter((category: Category) => category.parentId === id);
  }

  private createHref(
    categoryName: string,
    categoryId: number,
    subCategoryName?: string,
    subCategoryId?: number,
    subSubCatId?: number,
  ): string {
    const sanitizedCatName = categoryName.replace(/[^a-zA-Z0-9]/g, "-");

    const basePath = ["/#/products/category", categoryId, sanitizedCatName];

    // Ajout du niveau 2 dans l'URL si présent
    if (subCategoryId !== undefined && subCategoryName) {
      basePath.push(
        subCategoryId,
        subCategoryName.replace(/[^a-zA-Z0-9]/g, "-"),
      );
    }

    // Déterminer l'ID à envoyer
    const idToSend =
      subSubCatId !== undefined
        ? subSubCatId
        : subCategoryId !== undefined
          ? subCategoryId
          : categoryId; // 👉 Niveau 1 envoie categoryId !!

    const queryParams = new URLSearchParams({
      categories: String(idToSend),
      inStock: "false",
    }).toString();

    return basePath.join("/") + `?${queryParams}`;
  }

  /**
   /**
   * handerlers for mon compte menu items
   */
  onMyProfileClick(): void {
    this.router.navigate(["account/profile/"]);
  }

  handleLoginEvent(loginData: any): void {
    this.toggleLoginModal(false);
  }

  onMyAdressClick(): void {
    this.cdr.markForCheck();
    this.router.navigate(["account/address/"]);
  }

  onMyDocsClick(): void {
    this.router.navigate(["account/files/"]);
  }

  onMyOrdersClick(): void {
    this.router.navigate(["account/orders/"]);
  }

  /** Favorites page, available logged out too (favorites kept in localStorage) */
  onMyFavoritesClick(): void {
    this.router.navigate(["account/favorites/"]);
  }

  gotoAssistance() {
    this.showMyAccountDropdownMenu = false;
    setTimeout(() => {
      this.router.navigate([`/assistance`]);
    }, 200);
  }

  toggleCart() {
    this.showMyAccountDropdownMenu = false;
    setTimeout(() => {
      this.router.navigateByUrl("/cart");
    }, 200);
  }

  gotoNosMagasin() {
    this.router.navigate([`/stores`]);
  }

  /** Relative links of the announcement bar are routed here; absolute http(s) ones are opened by lib-header. */
  onAnnouncementClick(announcement: HeaderAnnouncement): void {
    const url = announcement.linkUrl;
    if (url && !/^https?:\/\//i.test(url)) {
      this.router.navigateByUrl(url).then();
    }
  }

  gotoContact() {
    this.router.navigate([`/contact`]);
  }

  onLogout() {
    const shouldRedirectHome = this.isCurrentRouteProtected();

    this.authService.logout().subscribe({
      next: () => {
        this.isConnected = false;
        this.user_name = "";
        if (shouldRedirectHome) {
          this.router.navigateByUrl("/");
        }
      },
      error: (err: any) => {
        console.error(err);
      },
    });
  }

  private isCurrentRouteProtected(): boolean {
    const containsAuthGuard = (route: ActivatedRouteSnapshot): boolean => {
      if (route.routeConfig?.canActivate?.includes(AuthGuard)) {
        return true;
      }
      return route.children.some((child) => containsAuthGuard(child));
    };

    return containsAuthGuard(this.router.routerState.snapshot.root);
  }

  navigateHome(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.router.url === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      this.router.navigateByUrl("/");
    }
  }

  navigateToCategory(event: { href: string; label?: string }) {
    if (!event || !event.href) {
      console.error("Invalid category navigation event:", event);
      return;
    }

    // Parse URL from the event
    try {
      // Remove the hash if present and get the path part

      const url = event.href.replace(/^#/, "");

      // Check if it's an internal URL (starts with /, /# omenur #/)
      if (url.startsWith("/#/")) {
        const path = url.substring(2); // Remove the '/#' prefix
        this.router.navigateByUrl(path);
      } else if (url.startsWith("#/")) {
        const path = url.substring(1); // Remove the '#' prefix
        this.router.navigateByUrl(path);
      } else {
        this.router.navigateByUrl(url);
      }
    } catch (error) {
      console.error("Error parsing navigation URL:", error);
      // Fallback to direct location change
      window.location.href = event.href;
    }
    this.isMobileMenuOpen = false;
    this.isMobileMenuOpen = false;
  }

  /**
   * @description user clicked enter or search button: go to the catalogue with the typed text as the search
   * @param {string} searchText the typed text in the search input
   */
  navigateToCatalogueProduct(searchText: string) {
    const term = searchText.trim();
    if (!term) return;

    this.router.navigate(["/products"], {
      queryParams: { search: term },
    });

    this.searchSuggestions = [];
  }

  /**
   * @description a suggestion was clicked: go to the product details page
   * @param {string} productName the clicked suggestion
   */
  navigateToProductDetails(productName: string) {
    const product = this.searchResults.find((p) => p.name === productName);
    if (!product) {
      return;
    }
    const slug = product.name
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9\-]/g, "")
      .replace(/-+/g, "-");

    const url = `/products/${slug}/${product.productId}/${product.id}`;

    this.router.navigateByUrl(url);
  }

  // Tabulation methods
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  toggleSideNav() {
    this.wissalStoreService.showNavMenu = true;
    this.wissalStoreService.showFilter = false;
    this.wissalStoreService.sideNavOpen = !this.wissalStoreService.sideNavOpen;
  }

  @HostListener("window:scroll")
  onFixNavbar() {
    if (
      !window.location.href.includes("/products/") ||
      window.location.href.includes("/products/category/")
    ) {
      if (window.scrollY > 100) {
        if (!this.isNavbarFixed) {
          this.isNavbar = false;
          setTimeout(() => {
            this.isNavbar = true;
          }, 10);
        }
        this.isNavbarFixed = true;
      } else {
        this.isNavbarFixed = false;
      }
    } else {
      this.isNavbarFixed = false;
    }
  }

  /**
   * @description navigate to selected brand
   */
  onBrandSelected(id: number) {
    this.router.navigate(["/products/brand", id, this.hoverdCategoryId], {
      queryParams: { inStock: "false" },
    });
  }

  /**
   * set the current hovered categoryId to be used in brands loading
   */
  onCategoryHovered(id: number) {
    this.hoverdCategoryId = id;
    this.getBrandsList();
    this.loadProductsForCategory(id);
  }

  /**
   * get brands list by hovered category id
   */
  getBrandsList() {
    this.brandService
      .getByCategoryId([this.hoverdCategoryId], "false")
      .subscribe({
        next: (brandsList: any) => {
          // keep just the brands with images
          this.brands = brandsList.filter(
            (brand: any) => brand.imageUrl !== "false",
          ) as Brand[];
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * Loads the first 7 in-stock products of the hovered category
   * (GET .../product-configurations/search-activated?pageNo=0&pageSize=8&category={id}&inStock=true)
   * and attaches them to that category so lib-tabulation's dropdown (selectedCategoryProducts,
   * reading `category.products`) can render the mini product cards, like on setycore.
   */
  loadProductsForCategory(categoryId: number) {
    const category = this.categories.find((cat) => cat.id === categoryId);
    if (!category) {
      return;
    }

    this.productService
      .getByFilter({ inStock: "true" }, [categoryId], 0, 8)
      .subscribe({
        next: (response: any) => {
          category.products = response.page.content.map((product: any) => ({
            productConfigId: product.id,
            title: product.name,
            productImage:
              product.images?.[0]?.url || this.DEFAULT_PRODUCT_IMAGE,
            price: product.price,
          }));
        },
        error: (err) => {
          console.error(err);
          category.products = [];
        },
      });
  }

  /**
   * @description navigate to the detail page of a product clicked in the menu dropdown preview
   */
  onProductClicked(product: { productConfigId: number }) {
    this.productConfigurationService
      .getByConfigurationId(product.productConfigId)
      .subscribe({
        next: (configuration) => {
          const safeName = (
            configuration.productName || configuration.name
          )?.replace(/\//g, "-");
          this.router.navigate([
            `/products/${safeName}/${configuration.productId}/${configuration.id}`,
          ]);
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * @description handle the click on the icon 'mon compte'
   */
  onMyAccountIconClicked() {
    if (this.isConnected) {
      if (this.showMyAccountDropdownMenu) {
        this.showMyAccountDropdownMenu = false;
      } else {
        this.updateMyAccountDropdownPosition();
        this.showMyAccountDropdownMenu = true;
      }
    } else {
      this.toggleLoginModal(true);
    }
  }

  /**
   * Positions the "my account" dropdown right under the account button,
   * using the library's own wrapper element as the reference point instead
   * of guessing a fixed offset.
   */
  private updateMyAccountDropdownPosition(): void {
    const iconEl = this.libHeaderComponent?.monCompteWrapperRef?.nativeElement;
    const wrapperEl = this.headerWrapperRef?.nativeElement;

    if (!iconEl || !wrapperEl) {
      return;
    }

    const iconRect = iconEl.getBoundingClientRect();
    const wrapperRect = wrapperEl.getBoundingClientRect();

    this.myAccountDropdownPosition = {
      top: iconRect.bottom - wrapperRect.top + 8,
      right: wrapperRect.right - iconRect.right,
    };
  }

  @HostListener("window:resize")
  onWindowResize(): void {
    if (this.showMyAccountDropdownMenu) {
      this.updateMyAccountDropdownPosition();
    }
  }

  // The account menu runs the item's handler itself; we only close the dropdown
  onMenuItemClick(): void {
    this.showMyAccountDropdownMenu = false;
  }

  onAccountMenuLogout(): void {
    this.showMyAccountDropdownMenu = false;
    this.onLogout();
  }

  /** Applies the current language (`layout.header`) to the texts passed to the library header. */
  private applyTranslations(header: LayoutTexts["header"]): void {
    this.placeholder = header["searchPlaceholder"];
    this.labels = header["labels"];
    this.tabulationLabels = header["tabulationLabels"];
    this.logoutLabel = header["accountMenu"].logout;

    this.tabs = HEADER_TABS.map(({ key, ...tab }) => ({
      ...tab,
      label: header["tabs"][key],
    }));
    this.setSelectedTab(this.router.url);

    this.quickLinks = HEADER_QUICK_LINKS.map((link) => ({
      ...link,
      label: header["quickLinks"][link.id],
    }));

    this.menuItems = this.menuItems.map((item) => ({
      ...item,
      label: header["accountMenu"][item.labelKey] ?? item.label,
    }));
  }

  private setActiveMenuItem(url: string): void {
    const path = url.split("?")[0];
    this.menuItems = this.menuItems.map((item) => ({
      ...item,
      active: path.startsWith(item.route),
    }));
  }

  selectedTab = this.tabs[0];

  private setSelectedTab(url: string): void {
    const path = url.split("?")[0];

    this.selectedTab =
      this.tabs.find((tab) =>
        tab.link !== "/" ? path.startsWith(tab.link) : path === "/",
      ) ?? this.tabs[0];
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.showMyAccountDropdownMenu) {
      return;
    }

    const target = event.target as Node;
    const iconEl = this.libHeaderComponent?.monCompteWrapperRef?.nativeElement;
    const dropdownEl = this.accountDropdownRef?.nativeElement;

    if (!iconEl?.contains(target) && !dropdownEl?.contains(target)) {
      this.showMyAccountDropdownMenu = false;
    }
  }
}
